import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface ICommitSalesOrderPayload {
    orderID: number;
}

async function commitSalesOrder(
    payload: ICommitSalesOrderPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/CommitSalesOrder",
        payload.orderID,
        { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
}

export function useCommitSalesOrderMutation() {
    return useMutation({
        mutationFn: commitSalesOrder,
    });
}
